import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dateformat } from 'src/app/models/commonModel';

@Component({
    selector: 'app-session-detail-dialog',
    templateUrl: './session-detail-dialog.component.html',
    styleUrls: ['./session-detail-dialog.component.scss'],
    standalone: false
})
export class SessionDetailDialogComponent implements OnInit {

  // Common Properties
  sessionDescription: any;
  dateFormat: any;

  constructor(
    private dialogRef: MatDialogRef<SessionDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.sessionDescription = data.description
  }

  ngOnInit(): void {
    this.dateFormat = dateformat;
  }

  cancel() {
    this.dialogRef.close();
  }
}